// src/components/ui/sections/ServicesList/ServicesListShadcn.jsx
import React, { useState } from 'react';
import {
  Plus,
  Search,
  Wrench
} from 'lucide-react';

// shadcn components
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../card';
import { Button } from '../../button';
import { Input } from '../../input';

// Import our custom components
import ServiceListItemShadcn from '../../cards/ServiceListItem/ServiceListItemShadcn';
import ServiceCreateFormShadcn from '../../forms/ServiceCreateForm/ServiceCreateFormShadcn';

const ServicesListShadcn = ({
  services = [],
  selectedServiceId,
  onSelectService,
  onCreateService,
  onDeleteService,
  searchTerm,
  onSearchChange,
  loading = false
}) => {
  const [showCreateForm, setShowCreateForm] = useState(false);

  const handleCreateService = (serviceData) => {
    onCreateService(serviceData);
    setShowCreateForm(false);
  };

  return (
    <Card className="h-full flex flex-col">
      {/* Header */}
      <CardHeader className="flex-shrink-0">
        <div className="flex items-center justify-between mb-4">
          <div>
            <CardTitle className="flex items-center gap-2">
              <Wrench className="w-5 h-5" />
              Services
            </CardTitle>
            <CardDescription>
              Manage your service offerings and pricing
            </CardDescription>
          </div>

          {/* Add Service Button */}
          <Button
            onClick={() => setShowCreateForm(true)}
            disabled={loading}
            size="sm"
          >
            <Plus className="mr-2 h-4 w-4" />
            {loading ? 'Creating...' : 'Add'}
          </Button>
        </div>

        {/* Search Bar */}
        <div className="relative">
          <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
          <Input
            type="text"
            placeholder="Search services..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-10"
          />
        </div>
      </CardHeader>

      {/* Services List */}
      <CardContent className="flex-1 min-h-0 overflow-y-auto space-y-3">
        {services.length === 0 ? (
          <div className="text-center py-12">
            <Wrench className="w-12 h-12 text-muted-foreground mx-auto mb-3" />
            <p className="text-muted-foreground text-sm">
              {searchTerm ? 'No services match your search' : 'No services created yet'}
            </p>
          </div>
        ) : (
          services.map((service) => (
            <ServiceListItemShadcn
              key={service.id}
              service={service}
              isSelected={selectedServiceId === service.id}
              onClick={() => onSelectService(service.id)}
              onDelete={() => onDeleteService(service)}
            />
          ))
        )}
      </CardContent>

      {/* Create Service Form Modal */}
      {showCreateForm && (
        <ServiceCreateFormShadcn
          onSave={handleCreateService}
          onCancel={() => setShowCreateForm(false)}
          loading={loading}
        />
      )}
    </Card>
  );
};

export default ServicesListShadcn;